/**
 * Confetti burst — uses canvas-confetti with Norea brand colors.
 */
import confetti from "canvas-confetti";

const NOREA_COLORS = ["#2E4734", "#4A7055", "#B8893F", "#7A9B82", "#245233"];

export function celebrate() {
  const duration = 1500;
  const end = Date.now() + duration;

  const frame = () => {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 70,
      origin: { x: 0, y: 0.7 },
      colors: NOREA_COLORS,
      gravity: 0.9,
      scalar: 1.1,
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 70,
      origin: { x: 1, y: 0.7 },
      colors: NOREA_COLORS,
      gravity: 0.9,
      scalar: 1.1,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  };

  // Initial big burst in the middle
  confetti({
    particleCount: 80,
    spread: 100,
    origin: { y: 0.55 },
    colors: NOREA_COLORS,
    startVelocity: 38,
    scalar: 1.2,
  });
  frame();
}
